import { render, staticRenderFns } from "./AnaliseDemandaCabecalhoCredenciamentoFornecedor.vue?vue&type=template&id=47ced381&scoped=true"
import script from "./AnaliseDemandaCabecalhoCredenciamentoFornecedor.vue?vue&type=script&lang=js"
export * from "./AnaliseDemandaCabecalhoCredenciamentoFornecedor.vue?vue&type=script&lang=js"
import style0 from "./AnaliseDemandaCabecalhoCredenciamentoFornecedor.vue?vue&type=style&index=0&id=47ced381&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ced381",
  null
  
)

export default component.exports